<template>
  <div class="container">
    <h2 class="text-center h1">{{ $tc("message.advantage.title") }}</h2>
    <div class="div-top">
      <b-row>
        <b-col
          md="2"
          offset-md="2"
          class="text-center"
          :class="{ selectedColor: statusShow === 0 }"
          @mouseenter="change(0)"
        >
          <div class="div">
            <img
              v-if="statusShow === 0"
              class="div-img"
              src="@/assets/images/home-header-advan_5.png"
            />
            <img
              v-else
              class="div-img"
              src="@/assets/images/home-header-advan_1.png"
            />
            <!-- {{ $tc('message.advantage.type', 0) }} -->
          </div>
        </b-col>
        <b-col
          md="2"
          offset-md="0"
          class="text-center"
          :class="{ selectedColor: statusShow === 1 }"
          @mouseenter="change(1)"
        >
          <div class="div">
            <img
              v-if="statusShow === 1"
              class="div-img"
              src="@/assets/images/home-header-advan_6.png"
            />
            <img
              v-else
              class="div-img"
              src="@/assets/images/home-header-advan_2.png"
            />
            <!-- {{ $tc('message.advantage.type', 1) }} -->
          </div>
        </b-col>
        <b-col
          md="2"
          offset-md="0"
          class="text-center"
          :class="{ selectedColor: statusShow === 2 }"
          @mouseenter="change(2)"
        >
          <div class="div">
            <img
              v-if="statusShow === 2"
              class="div-img"
              src="@/assets/images/home-header-advan_7.png"
            />
            <img
              v-else
              class="div-img"
              src="@/assets/images/home-header-advan_3.png"
            />
            <!-- {{ $tc('message.advantage.type', 2) }} -->
          </div>
        </b-col>
        <b-col
          md="2"
          offset-md="0"
          class="text-center"
          :class="{ selectedColor: statusShow === 3 }"
          @mouseenter="change(3)"
        >
          <div class="div">
            <img
              v-if="statusShow === 3"
              class="div-img"
              src="@/assets/images/home-header-advan_8.png"
            />
            <img
              v-else
              class="div-img"
              src="@/assets/images/home-header-advan_4.png"
            />
            <!-- {{ $tc('message.advantage.type', 3) }} -->
          </div>
        </b-col>
      </b-row>
      <b-row class="info-top">
        <b-col
          md="8"
          offset-md="2"
          class="text-left info-color"
          v-if="statusShow === 0"
        >
          {{ $tc("message.advantage.info1", 1) }}
        </b-col>
        <b-col
          md="8"
          offset-md="2"
          class="text-left info-color"
          v-if="statusShow === 1"
        >
          {{ $tc("message.advantage.info2", 1) }}
        </b-col>
        <b-col
          md="8"
          offset-md="2"
          class="text-left info-color"
          v-if="statusShow === 2"
        >
          {{ $tc("message.advantage.info3", 1) }}
        </b-col>
        <b-col
          md="8"
          offset-md="2"
          class="text-left info-color"
          v-if="statusShow === 3"
        >
          {{ $tc("message.advantage.info4", 1) }}
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeContentAdvantage",
  data() {
    return {
      statusShow: 0
    };
  },
  methods: {
    change(change) {
      this.statusShow = change;
    }
  }
};
</script>

<style lang="stylus" scoped>
.h1 {
  padding-top: 5rem;
  color: #333333;
  font-size: 1.9rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.9rem;
  letter-spacing: 0rem;
}

.div-top {
  margin-top: 5rem;

  .div {
    padding: 0.1rem 0.1rem;
    height: 100%;

    .div-img {
      width: 100%;
    }
  }
}

.selectedColor {
  background-color: #272727;
}

.info-color {
  height: 80px;
  color: #999999;
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-family: PingFang-SC-Regular;
  font-size: 1.2rem;
  line-height: 1.3rem;
  letter-spacing: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentAdvantage.vue